import { RING_MAX_AGE_MS } from "@repo/conferencing";

import type { RingDelivery } from "./incoming-ring";

interface CallSoundState {
  activeCallId: string | undefined;
  outgoingCallId: string | undefined;
  answeredCallId: string | undefined;
}

export function callSoundDecision(
  event: RingDelivery | { kind: "ringback"; callId: string; ageMs: number } | { kind: "leave" },
  state: CallSoundState,
): "ringback" | "stop" | "declined" | "hangUp" | "none" {
  // Leave runs after the room closes, and confirms the press for either party.
  if (event.kind === "leave") return "hangUp";
  if (event.kind !== "ringback" && event.kind !== "unanswered") return "none";
  const waiting =
    state.activeCallId === event.callId &&
    state.outgoingCallId === event.callId &&
    state.answeredCallId !== event.callId;
  if (event.kind === "unanswered") return waiting ? (event.status === "declined" ? "declined" : "stop") : "none";
  return waiting && event.ageMs < RING_MAX_AGE_MS ? "ringback" : "stop";
}
